<template>
  <v-form class='createMachineForm' v-model='valid' ref='createMachineForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols="12" md="3" sm="6" xs="12" class="d-none">
          <module-prefix :module="'machine'" :prefix.sync="machine.prefix" :no.sync="machine.no" v-if="!machine.id"/>
          <v-text-field
            v-model="machine.prefix"
            label='Prefix'
            placeholder='Prefix'
            v-if="machine.id"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12" class="d-none">
          <v-text-field
          v-model='machine.no'
          :error-messages='error.no'
          label='No'
          placeholder='No'
          readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
          label='Machine'
          placeholder='Machine'
          :value="bindMachineNo"
          readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model='machine.machine_serial_no'
            :error-messages='error.machine_serial_no'
            label='Machine Serial No'
            placeholder='Machine Serial No'
            autofocus
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="machine.purchase_date"
            :error-messages="error.purchase_date"
            type="date"
            label="Purchase Date"
            ref="firstInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="machine.installation_date"
            :error-messages="error.installation_date"
            type="date"
            label="Installation Date"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="machine.warranty_exp_date"
            :error-messages="error.warranty_exp_date"
            type="date"
            label="Warranty Expiry Date"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <searchable-select :value.sync="machine.machine_type_id" :options="{ url: 'machine_type', label: 'Machine Type'}" :errorMessage="error.machine_type_id" :selectedData="{'id': machine.machine_type_id, 'text': machine.machine_type_name}" :addNew="{right: 'edit_machine_type', module: 'machineType', title: 'Create Machine Type'}"/>
        </v-col>
        <!-- <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='machine.company_id'
            :error-messages='error.company_id'
            label='Company'
            placeholder='Select Company'
          ></v-text-field>
        </v-col> -->
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='machine.brand'
            :error-messages='error.brand'
            label='Brand'
            placeholder='Brand'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='machine.model'
            :error-messages='error.model'
            label='Model'
            placeholder='Model'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='machine.amperage_60_duty'
            :error-messages='error.amperage_60_duty'
            label='Amperage 60 Duty'
            placeholder='Amperage 60 Duty'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='machine.amperage_100_duty'
            :error-messages='error.amperage_100_duty'
            label='Amperage 100 Duty'
            placeholder='Amperage 100 Duty'
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-textarea
            v-model="machine.remarks"
            label="Remarks"
            placeholder="Remarks"
            rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="machine.status" row>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  computed: {
    bindMachineNo () {
      return this.machine.prefix + ((this.machine.no ? this.machine.no : '').toString().padStart(4, '0'))
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      this.getDataById(id)
    } else {
      this.edit_id = undefined
      const storageData = localStorage.getItem('clone_data')
      if (storageData) {
        const _storageData = JSON.parse(storageData)
        this.getDataById(_storageData.module_id)
      }
      localStorage.removeItem('clone_data')
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      machine: { prefix: '', no: '', status: 0 },
      error: {}
    }
  },
  methods: {
    getDataById (id) {
      this.$axios.post('getMachineById/' + id).then((res) => {
        this.machine = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    },
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'saveMachine/' + this.edit_id : 'saveMachine'
        this.$axios.post(route, this.machine).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/machine')
          } else {
            const resData = res.data.data
            this.reset(resData)
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createMachineForm.validate()
      }
    },
    reset (resData = {}) {
      // when form reset set old prefix and no for continute the sequence
      const oldPrefix = resData.prefix
      const oldSrNo = resData.no
      this.$refs.createMachineForm.reset()
      setTimeout(() => {
        this.machine = { prefix: oldPrefix, no: oldSrNo, status: 0 }
        this.error = {}
        this.$refs.firstInput.focus()
      }, 300)
    },
  },
}
</script>

<style>
.createMachineForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createMachineForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
